import { InternalType, LinkType } from "@bared/groq";
import { useSettings } from "@hooks/useSettings";
import { ComponentProps, GatsbyCustomImage } from "@ts/components";
import React, { FC } from "react";

import { useLiveChat } from "~/hooks/useLiveChat";

export type ServiceHighlightsInputProps = ComponentProps;

export type ServiceHighlightsOutputProps = ServiceHighlightsInputProps & {
  delay?: number;
  items: {
    _key: string;
    title?: string;
    image?: GatsbyCustomImage;
    textLink?: LinkType[] | InternalType[];
    imageReverse?: boolean;
    liveChat?: boolean;
  }[];
  openLiveChat: () => void;
};

export const withServiceHighlights =
  (Component: FC<ServiceHighlightsOutputProps>) =>
  ({ name = "Highlights" }: ServiceHighlightsInputProps) => {
    const { serviceHighlights } = useSettings();
    const { items, enabled, delay } = serviceHighlights || {};

    const liveChat = useLiveChat();

    Component.displayName = name;

    if (!enabled) {
      return null;
    }

    return (
      <Component
        items={items}
        delay={delay}
        openLiveChat={() => liveChat.open()}
      />
    );
  };
